import React, { useEffect } from "react";
import { connect } from "react-redux";
import { jwtDecode } from 'jwt-decode';
import { loginWithSamlUser, setHelpList } from "../../../common/actions/userAccount/userAccountAction";
import { useNavigate } from "react-router-dom";
import GLOBAL_CONST from "../../../helper/AppConstants";

function SamlResponse(props) {
  const navigate = useNavigate(); 

  const showSamlErrorAlert = () => {
    alert(
      "We apologize, but we are unable to process your request at the moment. Please contact support for assistance."
    );
  };

  const processURL = (url) => {
    try {
      const decodedUrl = decodeURIComponent(url);

      const urlParams = new URLSearchParams(decodedUrl.split("?")[1] || "");
      let jwtToken =
      urlParams.get("Data") ||
      urlParams.get("data") ||
      urlParams.get("token") ||
      urlParams.get("Token");

      if (!jwtToken) {
        showSamlErrorAlert();
        return;
      }


      const decoded = jwtDecode(jwtToken);
      if (decoded && decoded.LoginResult) {
        const parsedLoginResult = JSON.parse(decoded.LoginResult);

        const loginResponse = {
          Success: true,
          Data: {
            ...parsedLoginResult,
          },
        };
        
        props.loginWithSamlUser(loginResponse, (res) => {
            if (res.Success) {
              navigate("/childManagement");
            } else {
              showSamlErrorAlert();
            }
          });         
      } else {
        showSamlErrorAlert();
      }
    } catch (error) {
      console.error("processURL error:", error);
      showSamlErrorAlert();
    }
  };

  useEffect(() => {

    const currentUrl = window.location.href;

    processURL(currentUrl);

    // Clean the URL after processing
    window.history.replaceState({}, document.title, window.location.pathname);
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>Processing SAML Response...</h2>
      <p>Please wait while we verify your login.</p>
    </div>
  );
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
    return {
      loginWithSamlUser: (response, callback) =>
    dispatch(loginWithSamlUser(response, callback)),
    };
  }


export default connect(mapStateToProps, mapDispatchToProps)(SamlResponse);
